export default __webpack_public_path__ + "static/media/Monger-HUD-Readout (Pressure).95c6858e.jpg";